var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('div',{staticClass:"live-pause-modal"},[_c('div',{staticClass:"container"},[_c('live-modal',{attrs:{"is-show":_vm.isShow,"confirm-handler":_vm.confirmPause},on:{"update:isShow":_vm.cancelConfirm}},[_vm._v(" 暂停直播时，观众将无法看到你的直播画面，单场直播只能暂停3次 ")])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }